module.exports = __webpack_public_path__ + "static/img/favicon.ad62cf4.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/favicon.ico
// module id = 8ie2
// module chunks = 1